"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemHealthDto = exports.SystemHealthComponentDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class SystemHealthComponentDto {}
exports.SystemHealthComponentDto = SystemHealthComponentDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SystemHealthComponentId
}), __metadata("design:type", String)], SystemHealthComponentDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SystemHealthComponentDto.prototype, "label", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SystemHealthStatus
}), __metadata("design:type", String)], SystemHealthComponentDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], SystemHealthComponentDto.prototype, "latencyMs", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], SystemHealthComponentDto.prototype, "message", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], SystemHealthComponentDto.prototype, "priority", void 0);
class SystemHealthDto {}
exports.SystemHealthDto = SystemHealthDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SystemHealthStatus
}), __metadata("design:type", String)], SystemHealthDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SystemHealthDto.prototype, "checkedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SystemHealthDto.prototype, "cached", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [SystemHealthComponentDto]
}), __metadata("design:type", Array)], SystemHealthDto.prototype, "components", void 0);
//# sourceMappingURL=SystemHealth.dto.js.map